import { IconButton, styled } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CARDS_CONTAINER,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER,
  LIGHT_CONTAINER_BORDER,
  PRIMARY_CONTAINER,
  PRIMARY_CONTAINER_BORDER,
  PRIMARY_HEADER_LINE,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  LIGHT_HEADER_LINE,
  PRIMARY_TEXT,
} = COLORS;

const $gutter = 30;

export const ScrollCont = styled('div')(({ theme }) => ({
  overflow: 'auto',

  paddingRight: 10,
}));

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PastAuditionsContainer = styled('div')(({ theme }) => ({
  background: DARK_CONTAINER_FIELDS_FLOATING,
  height: 62,
  borderRadius: 8,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '10px 15px',
  gap: 15,
  opacity: 0.5,
}));

export const PastAuditionsCount = styled('div')(({ theme }) => ({
  height: 31,
  width: 31,
  borderStyle: 'solid',
  borderWidth: '2px',
  borderImageSource: `linear-gradient(253deg, ${PRIMARY_CONTAINER_BORDER}, ${LIGHT_CONTAINER_BORDER})`,
  borderImageSlice: '1',
  backgroundImage: `linear-gradient(to bottom, ${DARK_CARDS_CONTAINER}, ${DARK_CARDS_CONTAINER}), linear-gradient(253deg, ${PRIMARY_CONTAINER},${LIGHT_CONTAINER})`,
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '25px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const PastAuditionsTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& > p': {
    lineHeight: 1.2,
  },
}));

export const CustomIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',

  '& .MuiSvgIcon-root': {
    width: 11,
    height: 11,
  },
}));

export const Content = styled('div')(({ theme }) => ({}));

export const ContentItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const AuditionItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 3}px)`,

  [theme.breakpoints.down(1850)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  position: 'relative',
  borderBottom:
    theme.palette.type === 'dark'
      ? `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}`
      : `1px solid ${LIGHT_HEADER_LINE} !important`,
  alignItems: 'center',
  paddingBottom: 15,
  margin: '0 0 20px',
  color: PRIMARY_TEXT,

  '&::before': {
    content: '""',
    background: PRIMARY_HEADER_LINE,
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));
